import { useState } from "react";
import { Modal, Button, Row, Col } from "antd";
import { MoneyCollectOutlined } from "@ant-design/icons";
import { observer } from "mobx-react-lite";
import SalaryList from "../../salary/SalaryList";
import PropTypes from "prop-types";
import ExportSalary from "./ExportSalary";
import { useStore } from "../../../app/stores/store";

const ViewSalaryBtn = () => {
  ViewSalaryBtn.propTypes = {
    onSubmit: PropTypes.func.isRequired,
  };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const {payrollStore} = useStore();
  const {setIsAdjustBtn} = payrollStore
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Button
        type="primary"
        style={{ backgroundColor: "#F78D2E" }}
        onClick={showModal}
      >
        <MoneyCollectOutlined />
        VIEW SALARY
      </Button>
      <Modal
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={900}
        destroyOnClose
      >
        <Row
          gutter={16}
          justify="space-between"
          align="middle"
          style={{ width: "100%" }}
        >
          <Col style={{ flex: 1, textAlign: "center" }}>
            <h1>EMPLOYEES SALARY</h1>
          </Col>
          <Col>
            <Button
              type="primary"
              style={{ backgroundColor: "#333A3C" }}
              onClick={()=>{
                setIsAdjustBtn(true)
              }}
            >
              <MoneyCollectOutlined/>
              ADJUST SALARY
            </Button>
          </Col>
          <Col>
            <ExportSalary />
          </Col>
        </Row>
        <SalaryList />
      </Modal>
    </>
  );
};

export default observer(ViewSalaryBtn);
